import { clientFetch, url } from "./fetch-client/fetch_client";

export type Country = {
	id: number;
	country_code: string;
	name: string;
	dial_code: string;
	is_debtor_disabled: boolean;
	is_freeloader_disabled: boolean;
	is_sepa_member: boolean;
	is_vies_required: boolean;
};

export type CountryList = {
	count: number;
	data: Country[];
};

export async function read_country_list(): Promise<CountryList> {
	const { ok, body } = await clientFetch(url`/api/debtor/country`).get();

	if (!ok) {
		return {
			count: 0,
			data: [],
		};
	}

	return body as CountryList;
}

export async function read_country(countryCode?: string): Promise<Country> {
	const countryList = await read_country_list();

	for (const country of countryList.data) {
		if (country.country_code === countryCode.toUpperCase()) {
			return country;
		}
	}

	throw new Error(`No country code found for '${countryCode}'`);
}
